import { createFileRoute, redirect } from '@tanstack/react-router';
import { TabbedPageLayout, type RoutedTab } from '@/components/tabbed-page-layout';

export const Route = createFileRoute(
  '/_auth/_side-layout/super-admin/enrichment',
)({
  component: () => (
    <TabbedPageLayout
      title="Enrichment"
      description="Provider credentials and the enrichment waterfall."
      tabs={TABS}
    />
  ),
  beforeLoad: async ({ context }) => {
    if (context.platformRole !== 'admin') {
      throw redirect({ to: '/' });
    }
  },
});

const TABS: RoutedTab[] = [
  { to: '/super-admin/enrichment/configuration', label: 'Configuration' },
  { to: '/super-admin/enrichment/providers', label: 'Providers' },
];
